/**
 * Footer: expand/collapse the link accordions depending on screen width.
 * @param {number} width - The width of the client's browser window.
 */
export function toggleAccordions(width: number): void {
	document.querySelectorAll('details.footer__col').forEach((el: Element) => {
		if (width > 839) {
			el.setAttribute('open', '');
		} else {
			el.removeAttribute('open');
		}
	});
}
